module.exports = __webpack_public_path__ + "static/media/blue_sky_thumb_even.67c168e4.jpg";